import { Form, Space, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import otherService from '../../../services/config/other.service';
import ticketService from '../../../services/ticket/ticket.service';
import moment from 'moment';
import numberHelper from '../../../helpers/functions/number.helper';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';

const GenerateConsolidateTicketList = ({ refresh, filter = {}, form, is_select_all, }) => {
    const [state, setState] = useState({
        loading : false,
        tickets : [],
        // use for auto set the checkbox of table
        selected_row_keys : [],

        document_lines : [],
    })

     const [sorter, setSorter] = useState({
        key : null,
        order : null,
    })

    const fetchTicketListing = async () => {
        setState(state => ({...state, loading : true, }));

        const paymentStatusResponse = await otherService.getPaymentStatus();
        
        const { park_id, start_date, end_date, purchase_type_ids, } = filter;
        const { key, order, } = sorter;
        //set filter on only completed payment status
        const complete_payment_status = paymentStatusResponse?.payment_statuses?.filter(x => x.is_payment_complete);
        const complete_payment_status_ids = complete_payment_status?.map(x => x.payment_status_id);

        const ticketListingResponse = await ticketService?.getTicketListing({
            park_ids : [park_id],
            payment_status_ids : complete_payment_status_ids,
            is_myinvois_documents : false,
            // payment date
            start_date, end_date,
            purchase_type_ids,

            is_all : true,

            // ordering
            order : key ?? "ticket_id",
            order_position : order ?? 'DESC',
        }).catch(err => {
            setState(state => ({...state, loading : false, }));
        });

        const { tickets : ticket_list, errors } = ticketListingResponse;
        const { rows : tickets, count : ticket_count } = ticket_list ?? {};

        const ticket_ids = tickets?.map(x => x?.ticket_id);
        // const selected_rows = is_select_all ? [...state?.selected_row_keys, ...(ticket_ids)] : [...state?.selected_row_keys];
        const selected_rows = [];

        // fetch submitted document of tickets
        const documentLineResponse = await myinvoisTransService?.fetchDocumentLine({ ticket_ids, status : 'Valid', });
        const { document_lines, } = documentLineResponse;

        setState(state => ({...state, loading : false, tickets, count : ticket_count, selected_row_keys : selected_rows, document_lines : document_lines, }));
    }

    useEffect(() => {
        if(filter?.park_id){
            fetchTicketListing();
        }
    }, [filter, refresh, sorter, state?.page]);

    return (
        <>
            <Form.Item name={"ticket_ids"} hidden />
            <Table
            loading={state?.loading}
            rowKey={'ticket_id'}
            className='hub-table bordered'
            dataSource={state?.tickets}
            rowSelection={{
                type : 'checkbox',
                onChange: (selectedRowKeys, selectedRows, info) => {
                    // const totalRows = state?.count;
                    // const is_all = selectedRowKeys.length === totalRows;

                    const is_all = info?.type === 'all' && selectedRows?.length > 0;
                    let selected_row_ticket_ids = [...selectedRows?.map(x => x?.ticket_id)];
                    // if(is_all) selected_row_ticket_ids = [...state?.selected_row_keys, ...selectedRows?.map(x => x?.ticket_id)];
                    
                    form.setFieldsValue({ ticket_ids : selected_row_ticket_ids, })
                    setState(state => ({...state, selected_row_keys : selected_row_ticket_ids, }));
                    // selectAll?.(is_all);
                },
                selectedRowKeys : state?.selected_row_keys,
                getCheckboxProps : (record => ({
                    disabled : state?.document_lines?.map(x => x?.ticket_id)?.includes(record?.ticket_id),
                })),
            }}
            onRow={record => {
                const is_disabled = state?.document_lines?.map(x => x?.ticket_id)?.includes(record?.ticket_id);
                return {
                    style : is_disabled ? { opacity : '0.2', } : {},
                }
            }}
            pagination={false}
            // pagination={{
            //     size : state?.display_size,
            //     // current : (ticketRedux?.count > state?.display_size) ? state?.page : 1, 
            //     total : state?.count,
            //     showSizeChanger: false,
            //     onChange : (page) => paginateChange('page', page)
            // }}
            columns={[
            // { dataIndex : 'ticket_id' },
            {
                title : 'Transaction No',
                dataIndex : 'unique_no',
                key : 'unique_no',
                render : (unique_no, row, index) => {
                    const { salt } = row;
                    return (
                        <>
                            <span>{`${unique_no}${salt ?? ''}`}</span>
                        </>
                    )
                }
            },{
                title : 'Purchase Type',
                dataIndex : 'purchase_type_name',
                key : 'purchase_type_name',
                // sorting features
                showSorterTooltip : false,
                sorter: true,
                render : (purchase_type_name, row, index) => {
                    return (
                        <>
                            {purchase_type_name}
                        </>
                    )
                }
            },{
                title : 'Amount',
                dataIndex : 'payment_amount',
                key : 'payment_amount',
                render : (payment_amount, row, index) => {
                    const { currency_code, currency_symbol, is_payment_complete, payment_date, } = row ?? {};
                    return (
                        <>
                            <div>
                                <div>
                                    <Space>
                                        <Tag color='blue' style={{border : 'none', }}>
                                            {currency_code}
                                        </Tag>
                                    </Space>
                                    <span>{`${currency_symbol}${numberHelper?.commaNumber(payment_amount)}`}</span>
                                </div>
                                <div>
                                    <Tag color={(is_payment_complete ? 'green' : 'orange')} style={{border:'none'}}>
                                        {
                                            is_payment_complete ?
                                            <>
                                                {`Paid: ${moment(payment_date)?.format("YYYY-MM-DD HH:mm:ssa")}`}
                                            </>
                                            :
                                            <>
                                                Pending Payment
                                            </>
                                        }
                                    </Tag>
                                </div>
                            </div>
                        </>
                    )
                }
            }]}
            />
        </>
    );
}

export default GenerateConsolidateTicketList;